import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';
import './Disclaimer.css';

/**
 * Legal disclaimers to limit liability.
 * variant: 'investment' | 'tax' | 'general' | 'compact'
 */
const Disclaimer = ({ variant = 'general' }) => {
  const content = {
    investment: (
      <>
        <strong>Investment Disclaimer:</strong> WealthCore is not a registered investment advisor, broker-dealer, or financial advisor. 
        All stock analysis, technical indicators, and pattern recognition are provided for <strong>educational and informational purposes only</strong>. 
        Nothing on this platform constitutes personalized investment advice, a recommendation to buy or sell any security, or tax advice. 
        Past performance does not indicate future results. Investing involves risk, including possible loss of principal. 
        You use this tool at your own risk. Always conduct your own research and consult a qualified financial professional before making investment decisions.
      </>
    ),
    tax: (
      <>
        <strong>Tax Disclaimer:</strong> WealthCore is not a certified public accountant (CPA), tax attorney, or licensed tax preparer. 
        All tax calculations, estimates, and planning tools are for <strong>educational and informational purposes only</strong>. 
        Tax laws change frequently; we do not guarantee accuracy, completeness, or applicability to your situation. 
        This is not a substitute for professional tax advice. You use these tools at your own risk. Consult a qualified CPA or tax attorney for your specific situation before filing or making tax-related decisions.
      </>
    ),
    general: (
      <>
        <strong>General Disclaimer:</strong> WealthCore provides tools for educational and informational purposes only. 
        We are not a registered investment advisor, CPA, tax attorney, or licensed financial professional. 
        All content, calculations, and recommendations are provided &quot;as is&quot; without warranty of any kind. 
        You are solely responsible for your financial decisions and use the Service at your own risk. Consult qualified professionals before acting on any information. 
        See our <Link to="/terms" className="underline font-medium">Terms of Service</Link> and <Link to="/privacy" className="underline font-medium">Privacy Policy</Link>.
      </>
    ),
    compact: (
      <>
        <strong>Disclaimer:</strong> For informational purposes only. Not investment, tax, or legal advice. No warranty. Use at your own risk. Consult qualified professionals.{' '}
        <Link to="/terms" className="underline font-medium">Terms</Link> · <Link to="/privacy" className="underline font-medium">Privacy</Link>
      </>
    )
  };

  return (
    <div className={`disclaimer disclaimer-${variant}`}>
      <div className="disclaimer-content">
        <AlertTriangle className="disclaimer-icon" size={20} />
        <div className="disclaimer-text">
          {content[variant] || content.general}
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
